import {FormInputProps} from "_types/form";
import {Form, InputGroup} from 'react-bootstrap';
import {useState} from "react";
import classNames from "classnames";
import MaskedInput from "react-text-mask";
import {Controller, get} from "react-hook-form";

export const PhoneInput = ({
    name,
    placeholder,
    refCallback,
    errors,
    control,
    register,
    className,
    ...otherProps
}: FormInputProps) => {
    const fieldErrors = get(errors, name);
    className = classNames(className, 'form-control', {'is-invalid': fieldErrors});

    const [mask, setMask] = useState(["(", /[1-9]/, /\d/, ")", " ", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]);

    return (
        <>
            <InputGroup className="mb-0">
                <Controller
                    {...{name, control}}
                    render={
                        ({field: {onChange, onBlur, value}}) => {
                            const handleChange = (e: any) => {
                                const _value = e.target.value.replace(/\D/g, "");
                                if (_value.length == 10) {
                                    setMask(["(", /[1-9]/, /\d/, ")", " ", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/]);
                                }
                                else if(_value.length >= 11) {
                                    setMask(["(", /[1-9]/, /\d/, ")", " ", /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]);
                                }
                                else {
                                    setMask(["(", /[1-9]/, /\d/, ")", " ", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]);
                                }

                                if (_value.length === 10 && e.target.value.includes('_')) {
                                    e.target.value = _value.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
                                }

                                if (_value.length === 11) {
                                    e.target.value = _value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
                                }
                                onChange(e);
                            };
                            return (
                                <MaskedInput
                                    defaultValue={value}
                                    {...{placeholder, className, mask, name}}
                                    id={name}
                                    onChange={handleChange}
                                    onBlur={onBlur}
                                    {...otherProps}
                                />
                            )
                        }
                    }/>
            </InputGroup>

            {fieldErrors ? (
                <Form.Control.Feedback type="invalid" className="d-block">
                    {fieldErrors['message'] as string}
                </Form.Control.Feedback>
            ) : null}
        </>
    );
};
